<div class="badge badge-{{status}}"> {{status| EnumToNamePipe: enumArray}} </div>

